import { useEffect } from "react";
/**
 * Execute a callback on window scroll.
 *
 * @param {Function} callback A function to execute on scroll
 * @param {Boolean} active A boolean indicating if this hook is active
 */

export default function useRepositionOnWindowScroll(callback, active) {
  useEffect(() => {
    if (active) {
      window.addEventListener("scroll", callback);
      return () => {
        window.removeEventListener("scroll", callback);
      };
    }
  }, [callback, active]);
}